import {defineStore} from "pinia";
import * as ContactService from "@/services/contact.service";
import {ref} from "vue";


export const useContactStore = defineStore('contact', () => {
    const loading = ref(false);
    const contactInfo = ref([]);

    async function getContactInfo() {
        loading.value = true;
        try {
            const response = await ContactService.getContactInfo();
            if (!response) {
                console.error("Info not found");
                contactInfo.value = [];
                return null;
            }
            contactInfo.value = response;
        } catch (error) {
            console.error("Error fetching contact info:", error);
            contactInfo.value = [];
        } finally {
            loading.value = false;
        }
    }

    return {
        contactInfo,
        getContactInfo
    };
});